import { render } from "./ErrorDialogComponent.vue?vue&type=template&id=3eef1133&scoped=true"
import script from "./ErrorDialogComponent.vue?vue&type=script&lang=js"
export * from "./ErrorDialogComponent.vue?vue&type=script&lang=js"

import "./ErrorDialogComponent.vue?vue&type=style&index=0&id=3eef1133&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eef1133"]])

export default __exports__